module.exports = __webpack_public_path__ + "v-static/img/roam-tip.3adaa55a.png";